import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
export function FestivalCardSkeleton() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="aspect-[343/268] w-full rounded-xsmall mobile:rounded-medium" />;
    t1 = <Skeleton className="h-24 w-200" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-12">{t0}{t1}<div className="flex flex-col gap-4"><Skeleton className="h-16 w-1/2" /><Skeleton className="h-16 w-2/3" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}